import { render } from "./MyFundsDetails.vue?vue&type=template&id=da152ca0&scoped=true"
import script from "./MyFundsDetails.vue?vue&type=script&lang=js"
export * from "./MyFundsDetails.vue?vue&type=script&lang=js"

import "./MyFundsDetails.vue?vue&type=style&index=0&id=da152ca0&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da152ca0"]])

export default __exports__